// extracted by mini-css-extract-plugin
export var messageSideLeft = "_if-1";
export var stateContainer = "_if-0";